export default __webpack_public_path__ + "static/media/fontRoboto700_greek.50e795c1.woff2";